/**
 * Entity-reference editor. Renders a <select> of resolved candidates when the
 * projection supplied `options`; otherwise degrades to an editable text input
 * (spec §5 safety valve) so the value is still visible, correctable, captured.
 */
import type { ProposalFieldEditorProps } from "../ProposalEditor.js";
import { controlStyle, fieldDomId } from "../ProposalEditor.js";

export function EntityRefField({ field, value, onChange, idPrefix }: ProposalFieldEditorProps) {
  const options = field.options ?? [];
  const current = value == null ? "" : String(value);

  if (options.length === 0) {
    return (
      <input
        id={fieldDomId(idPrefix, field.key)}
        type="text"
        aria-label={field.label}
        style={controlStyle}
        value={current}
        onChange={(e) => onChange(e.target.value)}
      />
    );
  }

  // If the current value isn't among the resolved options, keep it selectable so
  // a staged value is never silently dropped.
  const hasCurrent = options.some((o) => o.value === current);
  return (
    <select
      id={fieldDomId(idPrefix, field.key)}
      aria-label={field.label}
      style={controlStyle}
      value={current}
      onChange={(e) => onChange(e.target.value)}
    >
      {!hasCurrent && current !== "" && <option value={current}>{current}</option>}
      {options.map((o) => (
        <option key={o.value} value={o.value}>
          {o.label}
        </option>
      ))}
    </select>
  );
}
